import React, { useState } from "react";
import { Button } from "@material-ui/core";
import styled from "@emotion/styled";
import { motion, AnimatePresence } from "framer-motion";
import { i18n, i18nTextId } from "../../../../../../i18n/i18nText";
import FormSelect from "../../../../../../components/Form/FormSelect/FormSelect";

const AbsoluteDiv = styled(motion.div)`
  width: 100vw;
  height: 100vh;

  position: fixed;
  top: 0px;
  left: 0px;

  background-color: #00000077;

  z-index: 99999;

  opacity: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  white-space: pre-line;
`;

const StyledButtonNext = styled(Button)`
  background-color: #2196f3 !important;
  color: #fff !important;

  &:hover {
    background-color: #06467a !important;
  }
`;

const StyledButtonCancel = styled(Button)`
  background-color: #9b9b9b !important;
  color: #fff !important;

  &:hover {
    background-color: #6e6e6e !important;
  }
`;

const ModalBox = styled(motion.div)`
  padding: 30px;

  background-color: white;

  display: grid;

  grid-template-areas:
    "Text Text"
    "Input Input"
    "Cancel Next";

  grid-row-gap: 30px;
  grid-column-gap: 20px;
`;

const TextArea = styled.div`
  grid-area: Text;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const InputArea = styled.div`
  grid-area: Input;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const CancelArea = styled.div`
  grid-area: Cancel;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const NextArea = styled.div`
  grid-area: Next;

  display: flex;
  justify-content: center;
  align-items: center;
`;

//

interface Props {
  openModal: boolean;
  setModal: any;
  text: string;
  childToParent: any;
  handleNext: any;
}

function MaintenanceModalReason(props: Props) {
  let { openModal, setModal, text, childToParent, handleNext } = props;

  const [modalData, setModalData] = useState(i18n("MAINTENANCE_REASON_NONE"));

  return (
    <AnimatePresence>
      {openModal && (
        <AbsoluteDiv
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <ModalBox initial={{ y: 1000 }} animate={{ y: 0 }} exit={{ y: 1000 }}>
            <TextArea>{i18n(text as i18nTextId)}</TextArea>

            <InputArea>
              <FormSelect
                id="maintenance-modal-reason-select"
                label={"MAINTENANCE_MODAL_REASON_LABEL"} // Selecione um motivo:
                state={[modalData, setModalData]}
                values={[
                  [i18n("MAINTENANCE_REASON_NONE"), "MAINTENANCE_REASON_NONE"],
                  [i18n("MAINTENANCE_REASON_01"), "MAINTENANCE_REASON_01"],
                  [i18n("MAINTENANCE_REASON_02"), "MAINTENANCE_REASON_02"],
                  [i18n("MAINTENANCE_REASON_03"), "MAINTENANCE_REASON_03"],
                  [i18n("MAINTENANCE_REASON_04"), "MAINTENANCE_REASON_04"],
                  [i18n("MAINTENANCE_REASON_05"), "MAINTENANCE_REASON_05"],
                  [i18n("MAINTENANCE_REASON_06"), "MAINTENANCE_REASON_06"],
                  [i18n("MAINTENANCE_REASON_07"), "MAINTENANCE_REASON_07"],
                  [i18n("MAINTENANCE_REASON_08"), "MAINTENANCE_REASON_08"],
                  [i18n("MAINTENANCE_REASON_09"), "MAINTENANCE_REASON_09"],
                  [i18n("MAINTENANCE_REASON_10"), "MAINTENANCE_REASON_10"],
                  [i18n("MAINTENANCE_REASON_11"), "MAINTENANCE_REASON_11"],
                  [i18n("MAINTENANCE_REASON_12"), "MAINTENANCE_REASON_12"],
                  [i18n("MAINTENANCE_REASON_13"), "MAINTENANCE_REASON_13"],
                ]}
              />
            </InputArea>

            <CancelArea>
              <StyledButtonCancel
                onClick={() => {
                  setModal(false);
                }}
              >
                {i18n("MAINTENANCE_MODALS_BUTTON_CANCEL")}
              </StyledButtonCancel>
            </CancelArea>

            <NextArea>
              <StyledButtonNext
                onClick={() => {
                  childToParent(modalData);
                  handleNext(true);
                  setModal(false);
                }}
              >
                {i18n("MAINTENANCE_MODALS_BUTTON_NEXT")}
              </StyledButtonNext>
            </NextArea>
          </ModalBox>
        </AbsoluteDiv>
      )}
    </AnimatePresence>
  );
}

export default MaintenanceModalReason;
